import { PrintService } from "./print.service";

/**
 * Do-nothing print service
 */
export class NoPrintService implements PrintService {
  /**
   * Page waits for print?
   */
  readonly pageWaitsForPrint = false;

  /**
   * Raise CSS print events?
   */
  readonly raiseCssPrintEvents = false;

  /**
   * Initialization logic
   */
  init(): void {
    //nothing to do
  }

  /**
   * Page data loaded callback
   */
  public pageDataLoaded(): void {
    //nothing to do
  }

  /**
   * Document data loaded callback
   */
  public documentDataLoaded(): void {
    //nothing to do
  }
}
